import Icons from './icons.vue'
export default Icons



// WEBPACK FOOTER //
// ./src/components/icons/index.js